import { render, staticRenderFns } from "./SystemWithActiveAlert.vue?vue&type=template&id=7b304f3a"
import script from "./SystemWithActiveAlert.vue?vue&type=script&lang=js"
export * from "./SystemWithActiveAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports